var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"a-button-the-modal-cancel-action",attrs:{"type":"button"},on:{"click":_vm.$modal.closeModal}},[_c('i',{staticClass:"far fa-times margin-right-xsmall"}),_vm._v(_vm._s(_vm.buttonCancelText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }